var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPointerBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66669 5.6C2.66669 2.504 5.05145 0 8.00002 0C10.9486 0 13.3334 2.504 13.3334 5.6C13.3334 9.8 8.00002 16 8.00002 16C8.00002 16 2.66669 9.8 2.66669 5.6ZM6.09528 5.59994C6.09528 6.70394 6.94861 7.59994 8.00004 7.59994C9.05147 7.59994 9.9048 6.70394 9.9048 5.59994C9.9048 4.49593 9.05147 3.59993 8.00004 3.59993C6.94861 3.59993 6.09528 4.49593 6.09528 5.59994Z",
    fill: "#0A6ADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPointerBlue);
export default __webpack_public_path__ + "static/media/Location-pointer-blue.6800899d9edecc9ccd5307140ec7d215.svg";
export { ForwardRef as ReactComponent };